module.exports = "<h2 id=\"component-description\">Component Description</h2>\n<p>A Nessie Checkbox is a single checkbox input. It consists of a (hidden) native <code>&lt;input type=&quot;checkbox&quot;&gt;</code> button and a <code>&lt;label&gt;</code> styled to replace the native input.</p>\n<h2 id=\"example-usage\">Example Usage</h2>\n<pre><code>&lt;Checkbox isChecked={ false }&gt;My checkbox&lt;/Checkbox&gt;\n</code></pre>";


//////////////////
// WEBPACK FOOTER
// ./node_modules/html-loader!./node_modules/markdown-loader!./src/Checkbox/README.md
// module id = 337
// module chunks = 0